export enum BuilderSelectType {
  IMAGE_POSITIONS,
  BUTTONS_POSITIONS,
  IMAGE_ROUNDED,
  GALLERY_STYLE,
  BUTTON_SIZE,
  VIEW_ROUNDED,
  PAGE_ID,
  LANGUAGE,
  FORM_POSITIONS,
  SELECTION_ORDER,
  EMPLOYEE_SELECTION_MODE,
  // Appended only: the numeric values are stored in every draft.
  GOOGLE_TAG_MODE,
  CONSENT_CATEGORY,
  PRIVACY_POLICY_TARGET,
  COOKIE_REOPEN
}
